module.exports = __webpack_public_path__ + "static/img/policyApply.d6b7386.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/linshi/policyApply.png
// module id = fa/Y
// module chunks = 44